import { render, staticRenderFns } from "./加盟代理.vue?vue&type=template&id=5224de40&scoped=true&"
import script from "./加盟代理.vue?vue&type=script&lang=js&"
export * from "./加盟代理.vue?vue&type=script&lang=js&"
import style0 from "./加盟代理.vue?vue&type=style&index=0&id=5224de40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224de40",
  null
  
)

export default component.exports